import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Estado',
      fields: {
        room_service_visible: {
          label: 'Servicio de habitación/mesa visible',
        },
        has_room_service: {
          label: 'Servicio de habitación/mesa',
        },
      },
    },
    settings: {
      title: 'Configuración',
      table_number: {
        label: 'Mostrar número de mesa',
      },
    },
    locations: {
      title: 'Ubicaciones',
    },
  },
  form: {
    google_place: {
      label: 'Nombre',
      placeholder: 'Nombre en Google Maps',
    },
    type: {
      label: 'Tipo',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Servicio de habitación',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Servicio de mesa',
      },
    },
    name: {
      label: 'Nombre de la ubicación',
      placeholder: 'Ingrese el nombre de la ubicación que sea claro para el cliente',
    },
    street_name: {
      label: 'Calle',
      placeholder: 'Nombre de la calle',
    },
    street_number: {
      label: 'Número de la calle',
      placeholder: 'Número de la calle',
    },
    city: {
      label: 'Ciudad',
      placeholder: 'Ciudad',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
  },
  fields: {
    id: 'id',
    type: 'Tipo',
    name: 'Nombre',
    address: 'Dirección',
    is_active: 'Activo',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Servicio de habitación',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Servicio de mesa',
  },
  modals: {
    delete_location: {
      title: '¿Está seguro?',
      description: 'Esto eliminará la ubicación «{{name}}»',
    },
  },
  buttons: {
    save: 'Guardar',
    delete: 'Eliminar',
  },
  toasts: {
    failed_to_load_locations: 'Error al cargar ubicaciones, recargue la página',
    failed_to_create_location: 'Error al crear la ubicación',
    failed_to_toggle_location: 'Error al cambiar la disponibilidad de la ubicación',
    failed_to_delete_location: 'Error al eliminar la ubicación',
    location_got_created: 'Ubicación creada correctamente',
    location_got_deleted: 'La ubicación fue eliminada',
    saving_success: 'Guardado correctamente',
    saving_error: 'Error al guardar',
  },
};
